<template>
  <section class="exhibition">
    <div class="title">
      <h2 class="content">服务详情</h2>
    </div>
    <div class="section">
      <div class="container">
        <div class="item">
          <div class="service-details">
            <h3 class="item-title">令人难以置信的基础设施</h3>
            <p class="text">Lorem Ipsum是印刷排版行业的虚拟文本。自16世纪以来，Lorem Ipsum一直是行业标准的虚拟文本，当时它还是一台不知名的打印机。</p>
            <p class="text">
              拿了一艘铅字船，把它搅和在一起做成了一本铅字标本。不仅存活了五个世纪，而且还跃进了电子时代。Lorem Ipsum是印刷排版行业的虚拟文本。
              自16世纪以来，Lorem Ipsum就一直是行业标准的虚拟文本，当时的打印机还是个未知数。
            </p>
          </div>
          <div class="image"><img src="./img/pic1.png"></div>
        </div>
        <div class="break"></div>
        <div class="item">
          <div class="image"><img src="./img/pic2.png"></div>
          <div class="service-details">
            <p class="text">
              拿了一艘铅字船，把它搅和在一起做成了一本铅字标本。不仅存活了五个世纪，而且还跃进了电子时代。Lorem Ipsum是印刷排版行业的虚拟文本。
              自16世纪以来，Lorem Ipsum就一直是行业标准的虚拟文本，当时的打印机还是个未知数。
            </p>
            <p class="text">Lorem Ipsum是印刷排版行业的虚拟文本。自16世纪以来，Lorem Ipsum一直是行业标准的虚拟文本，当时它还是一台不知名的打印机。</p>
            <p class="text">自16世纪以来，Lorem Ipsum就一直是行业标准的虚拟文本，当时的打印机还是个未知数。</p>        
          </div>
        </div>
      </div>
    </div>  
  </section>
</template>

<script>
export default {
  name: 'ServiceDetails'
}
</script>

<style lang="scss" scoped>
p {
  margin-top: 0;
  margin-bottom: 1rem;
}
.exhibition {
  margin: 0 auto;
}

.title {
  width: 100%;
  padding: 140px 0 130px;
  margin-top: 65px;
  background: url('../../assets/img/banner-bg1.jpg') center no-repeat;

  .content {
    font-size: 24px;
    font-weight: 700;
    color: #0e314c;
  }
}

.section {
  padding: 80px 0;

  @media (max-width: 745px) {
    padding: 50px 0;
  }
}

.container {
  width: 1140px;
  padding: 0 15px;
  margin: 0 auto;
  box-sizing: border-box;

  .item {
    display: flex;
    box-sizing: border-box;
    justify-content: center;

    .service-details {
      display: flex;
      flex-flow: column wrap;
      justify-content: center;
      text-align: left;
      padding: 0 15px;

      .item-title {
        color: #0e314c;
        font-size: 18px;
        margin: 0 0 15px;
      }

      .text {
        font-size: 14px;
        color: #6084a4;
        line-height: 1.9;
      }
    }

    .image {
      padding: 0 15px;

      img {
        width: 450px;
      }
    }
  }

  .break {
    margin-bottom: 80px;
  }

  @media (max-width: 745px) {
    .item {
      .service-details, .image {
        width: 100%;
      }
    }
  }

  @media (max-width: 1023px) {
    width: 100%;
    padding: 0 15px;
    margin: 0;

    .item {
      flex-flow: column;
      width: 100%;

      .service-details, .image{
        width: 100%;
        padding: 0;
      }

      .service-details {
        -webkit-box-ordinal-group: 2;
        order: 1;

        .item-title {
          margin: 0 0 15px;
        }
      }

      .image {
        -webkit-box-ordinal-group: 3;
        order: 2;
        margin-top: 30px;

        img {
          width: 100%;
        }
      }
    }  

    .break {
      margin: 40px 0 0;
    }
  }

  @media (min-width: 768px) and (max-width: 1023px) {
    max-width: 720px;
    margin: 0 24px;
  }

  @media (width: 1024px) {
    max-width: 960px;

    .service-details {
      position: relative;

      .item-title {
        position: absolute;
        top: 15px;
        margin-bottom: 0;
      }
    }
  }

  @media (min-width: 1025px) {
    max-width: 1140px;
  }
}
</style>